import { useNavigate } from 'react-router-dom';
import { Table, Button, Switch, Tag, Tooltip, Popconfirm, message, Modal, Form, Select, DatePicker, Alert, Input, Space, Typography, Divider, Radio } from 'antd';

const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
import { useEffect, useState } from 'react';
import MainLayout from '../../components/MainLayout';
import { routes } from '../../utils/routes.config';
import { DeleteOutlined, EditOutlined, EyeOutlined, PoweroffOutlined, DollarOutlined, PlusOutlined, ShopOutlined, UserOutlined, LockOutlined, CopyOutlined, CheckCircleOutlined, ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';
import useFetch from '../../Hooks/FetchData';
import { ApiConfig } from '../../services/ApiConfigs';
import { ApiServices } from '../../services/apiServices';
import planService from '../../services/planService';
import planPaymentService from '../../services/planPaymentService';
import { successMsg, errorMsg } from '../../utils/ShowMessage';
import moment from 'moment';

const Dashboard = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [onboardingForm] = Form.useForm();
    const [planModalVisible, setPlanModalVisible] = useState(false);
    const [onboardingModalVisible, setOnboardingModalVisible] = useState(false);
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [onboardingData, setOnboardingData] = useState<any>(null);
    const [onboardingLoading, setOnboardingLoading] = useState(false);
    const [selectedStore, setSelectedStore] = useState<any>(null);
    const [assignLoading, setAssignLoading] = useState(false);
    const [paymentEnabled, setPaymentEnabled] = useState(false);
    const [assignPaymentMode, setAssignPaymentMode] = useState<'razorpay' | 'manual'>('razorpay');
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState<{ id: number; name: string } | null>(null);
    const [deleteLoading, setDeleteLoading] = useState(false);

    useEffect(() => {
        planPaymentService.getPaymentConfig().then((config) => {
            const enabled = !!config?.enabled && !!config?.keyId;
            setPaymentEnabled(enabled);
            setAssignPaymentMode(enabled ? 'razorpay' : 'manual');
        }).catch(() => {
            setPaymentEnabled(false);
            setAssignPaymentMode('manual');
        });
    }, []);

    const { data: STORES, error, loading, refetch } = useFetch(ApiConfig.STORES, { trigger: true, });
    const { data: plans } = useFetch(ApiConfig.PLANS_ACTIVE, { trigger: true });

    const [stores, setStores] = useState([] as any);

    useEffect(() => {
        console.log(STORES, "STORES")
        setStores(STORES)
    }, [STORES])


    const toggleStoreStatus = (id: any) => {
        const updatedStores = stores.map(store =>
            store.id === id ? { ...store, status: !store.status } : store
        );
        setStores(updatedStores);
    };

    // const columns = [
    //     {
    //         title: 'Image',
    //         dataIndex: 'image',
    //         key: 'image',
    //         render: (text, record) => (
    //             <img src={record.image} alt={record.name} style={{ width: 100, borderRadius: 5 }} />
    //         )
    //     },
    //     {
    //         title: 'Name',
    //         dataIndex: 'name',
    //         key: 'name',
    //         render: (text) => <strong>{text}</strong>
    //     },
    //     {
    //         title: 'Details',
    //         dataIndex: 'details',
    //         key: 'details'
    //     },
    //     {
    //         title: 'Start Date',
    //         dataIndex: 'startDate',
    //         key: 'startDate'
    //     },
    //     {
    //         title: 'End Date',
    //         dataIndex: 'endDate',
    //         key: 'endDate'
    //     },
    //     {
    //         title: 'Status',
    //         key: 'status',
    //         render: (_, record) => (
    //             <Tag color={record.status ? 'green' : 'red'}>
    //                 {record.status ? 'Enabled' : 'Disabled'}
    //             </Tag>
    //         )
    //     },

    //     {
    //         title: 'Action',
    //         key: 'action',
    //         render: (_, record) => (
    //             <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
    //                 <Tooltip title={record.status ? 'Disable' : 'Enable'}>
    //                     <Button
    //                         shape="circle"
    //                         icon={<PoweroffOutlined />}
    //                         size='small'
    //                         type={record.status ? 'primary' : 'default'}
    //                         onClick={() => toggleStoreStatus(record.id)}
    //                     />
    //                 </Tooltip>

    //                 <Tooltip title="View Orders">
    //                     <Button
    //                         shape="circle"
    //                         size='small'
    //                         icon={<EyeOutlined />}
    //                         onClick={() => navigate(routes.Orders)}
    //                     />
    //                 </Tooltip>

    //                 <Tooltip title="Edit Store">
    //                     <Button
    //                         shape="circle"
    //                         size='small'
    //                         icon={<EditOutlined />}
    //                         onClick={() => console.log('Edit store', record.id)}
    //                     />
    //                 </Tooltip>

    //                 <Tooltip title="Delete Store">
    //                     <Button
    //                         shape="circle"
    //                         size='small'
    //                         icon={<DeleteOutlined />}
    //                         danger
    //                         onClick={() => console.log('Delete store', record.id)}
    //                     />
    //                 </Tooltip>
    //             </div>
    //         )
    //     }
    // ];

    const openDeleteModal = (record: any) => {
        setDeleteTarget({ id: record.id, name: record.name });
        setDeleteModalVisible(true);
    };

    const handleDeleteStore = async () => {
        if (!deleteTarget) return;
        setDeleteLoading(true);
        try {
            await ApiServices('delete', `${ApiConfig.STORES}/${deleteTarget.id}`);
            message.success('Store deleted successfully');
            setDeleteModalVisible(false);
            setDeleteTarget(null);
            refetch();
        } catch (error) {
            message.error('Failed to delete store');
            console.error(error);
        } finally {
            setDeleteLoading(false);
        }
    };

    const handleAssignPlan = async (values: any) => {
        if (!values.planId) {
            message.error('Please select a plan');
            return;
        }

        const selectedPlan = plans?.find((p: any) => p.id === values.planId);
        const planPrice = parseFloat(selectedPlan?.price) || 0;
        const endDate = values.endDate ? values.endDate.format('YYYY-MM-DD') : null;
        const useRazorpay = paymentEnabled && planPrice > 0 && assignPaymentMode === 'razorpay';

        setAssignLoading(true);
        try {
            let response;
            if (useRazorpay) {
                response = await planPaymentService.purchasePlanWithRazorpay({
                    storeId: selectedStore?.id,
                    planId: values.planId,
                    endDate,
                    planName: selectedPlan?.name,
                    planPrice,
                    user: { email: selectedStore?.adminEmail, name: selectedStore?.name },
                });
            } else {
                response = await planService.assignPlanToStore({
                    storeId: selectedStore?.id,
                    planId: values.planId,
                    endDate,
                    skipPayment: planPrice > 0,
                });
            }

            if (response?.success) {
                message.success(
                    useRazorpay
                        ? 'Payment successful. Plan assigned.'
                        : 'Plan assigned successfully'
                );
                setPlanModalVisible(false);
                form.resetFields();
                setSelectedStore(null);
                refetch();
            } else {
                message.error(response?.message || 'Failed to assign plan');
            }
        } catch (error: any) {
            console.error('Assign plan error:', error);
            if (error.message !== 'Payment cancelled') {
                message.error(error.message || 'Failed to assign plan');
            }
        } finally {
            setAssignLoading(false);
        }
    };

    const handleOpenPlanModal = (store: any) => {
        setSelectedStore(store);
        setPlanModalVisible(true);
        // Reset form when opening modal
        form.resetFields();
    };

    const handleCopy = (text: string, label: string) => {
        navigator.clipboard.writeText(text).then(() => {
            successMsg(`${label} copied to clipboard!`);
        }).catch(() => {
            errorMsg("Failed to copy to clipboard");
        });
    };

    const columns = [
        {
            title: 'Image',
            dataIndex: 'image',
            key: 'image',
            render: (_: string, record: any) => {
                const defaultImage = "https://placehold.co/600x400/000000/FFFFFF/png";
                const imageUrl = record.image || defaultImage;

                return (
                    <img
                        src={imageUrl}
                        alt={record.name}
                        style={{ width: 100, borderRadius: 5 }}
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = defaultImage;
                        }}
                    />
                );
            },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text: string) => <strong>{text}</strong>,
        },
        {
            title: 'Store URL',
            dataIndex: 'shopUrl',
            key: 'shopUrl',
            render: (url: string) => (
                <a href={url.startsWith('http') ? url : `https://${url}`} target="_blank" rel="noopener noreferrer">
                    {url}
                </a>
            ),
        },
        {
            title: 'Details',
            dataIndex: 'details',
            key: 'details',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_: any, record: any) => (
                <Tag color={record.status ? 'green' : 'red'}>
                    {record.status ? 'Enabled' : 'Disabled'}
                </Tag>
            ),
        },
        {
            title: 'Plan',
            key: 'plan',
            render: (_: any, record: any) => {
                // Plan info will be fetched from StorePlan via API
                // For now, show activePlanId if available
                if (record.activePlanId) {
                    return <Tag color="green">Plan Assigned</Tag>;
                }
                return <Tag color="default">No Plan</Tag>;
            },
        },
        {
            title: 'Actions',
            key: 'action',
            render: (_: any, record: any) => (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <Tooltip title="Assign Plan">
                        <Button
                            shape="circle"
                            size="small"
                            icon={<DollarOutlined style={{ color: '#16a34a' }} />}
                            style={{ border: '1.5px solid #bbf7d0', background: '#f0fdf4' }}
                            onClick={() => handleOpenPlanModal(record)}
                        />
                    </Tooltip>

                    <Tooltip title={record.status ? 'Disable Store' : 'Enable Store'}>
                        <Button
                            shape="circle"
                            size="small"
                            icon={<PoweroffOutlined style={{ color: record.status ? '#fff' : '#d97706' }} />}
                            style={record.status
                                ? { border: 'none', background: '#4f46e5' }
                                : { border: '1.5px solid #fde68a', background: '#fffbeb' }
                            }
                            onClick={() => toggleStoreStatus(record.id)}
                        />
                    </Tooltip>

                    <Tooltip title="View Details">
                        <Button
                            shape="circle"
                            size="small"
                            icon={<EyeOutlined style={{ color: '#0284c7' }} />}
                            style={{ border: '1.5px solid #bae6fd', background: '#f0f9ff' }}
                            onClick={() => navigate(`/admin/stores/${record.id}`)}
                        />
                    </Tooltip>

                    <Tooltip title="Delete Store">
                        <Button
                            shape="circle"
                            size="small"
                            icon={<DeleteOutlined style={{ color: '#dc2626' }} />}
                            style={{ border: '1.5px solid #fecaca', background: '#fef2f2' }}
                            onClick={() => openDeleteModal(record)}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];

    return (
        <MainLayout>
            <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 style={{ margin: 0 }}>Stores</h2>
                <Button 
                    type="primary" 
                    icon={<PlusOutlined />}
                    onClick={() => navigate(routes.STORE_CREATE)}
                    size="large"
                >
                    Add Store
                </Button>
            </div>
            <Table
                dataSource={stores}
                columns={columns}
                rowKey="id"
                pagination={{ pageSize: 5 }}
                scroll={{ x: 'max-content' }}
                loading={loading}
            />

            {/* Plan Assignment Modal */}
            <Modal
                title={`Assign Plan to ${selectedStore?.name || 'Store'}`}
                open={planModalVisible}
                onCancel={() => {
                    setPlanModalVisible(false);
                    form.resetFields();
                    setSelectedStore(null);
                }}
                footer={null}
                width={600}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleAssignPlan}
                >
                    <Alert
                        message="Plan will start immediately"
                        description="Choose payment method for paid plans, or assign without payment for complimentary access."
                        type="info"
                        showIcon
                        style={{ marginBottom: 16 }}
                    />

                    {paymentEnabled && (
                        <Form.Item label="Payment method">
                            <Radio.Group
                                value={assignPaymentMode}
                                onChange={(e) => setAssignPaymentMode(e.target.value)}
                            >
                                <Radio value="razorpay">Collect payment via Razorpay</Radio>
                                <Radio value="manual">Assign without payment (complimentary)</Radio>
                            </Radio.Group>
                        </Form.Item>
                    )}

                    <Form.Item
                        name="planId"
                        label="Select Plan"
                        rules={[
                            { required: true, message: 'Please select a plan' },
                            {
                                validator: (_, value) => {
                                    if (!value) {
                                        return Promise.reject(new Error('Please select a plan'));
                                    }
                                    return Promise.resolve();
                                }
                            }
                        ]}
                    >
                        <Select 
                            placeholder="Select a plan"
                            showSearch
                            optionFilterProp="children"
                            onChange={(value) => {
                                console.log('Plan selected:', value);
                                form.setFieldsValue({ planId: value, endDate: null });
                            }}
                            value={form.getFieldValue('planId')}
                        >
                            {plans?.map((plan: any) => (
                                <Option key={plan.id} value={plan.id}>
                                    {plan.name} - {plan.currencySymbol}{plan.price} 
                                    {plan.planType === 'subscription' ? ` / ${plan.billingPeriod}` : ' (One-Time)'}
                                    {plan.planType === 'one_time' && ' - Lifetime'}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.planId !== currentValues.planId}>
                        {({ getFieldValue }) => {
                            const selectedPlanId = getFieldValue('planId');
                            const selectedPlan = plans?.find((p: any) => p.id === selectedPlanId);
                            
                            if (selectedPlan?.planType === 'subscription') {
                                return (
                                    <Form.Item
                                        name="endDate"
                                        label="End Date (Optional - Leave empty to auto-calculate based on billing period)"
                                    >
                                        <DatePicker style={{ width: '100%' }} />
                                    </Form.Item>
                                );
                            }
                            
                            if (selectedPlan?.planType === 'one_time') {
                                return (
                                    <Alert
                                        message="One-Time Plan"
                                        description="This is a one-time payment plan with lifetime access. No end date required."
                                        type="success"
                                        showIcon
                                        style={{ marginBottom: 16 }}
                                    />
                                );
                            }
                            
                            return null;
                        }}
                    </Form.Item>

                    <Form.Item shouldUpdate>
                        {({ getFieldValue }) => {
                            const planId = getFieldValue('planId');
                            const plan = plans?.find((p: any) => p.id === planId);
                            const price = parseFloat(plan?.price) || 0;
                            const payLabel = paymentEnabled && price > 0 && assignPaymentMode === 'razorpay';
                            return (
                                <Button type="primary" htmlType="submit" block loading={assignLoading}>
                                    {payLabel ? 'Pay with Razorpay & Assign' : 'Assign Plan'}
                                </Button>
                            );
                        }}
                    </Form.Item>
                </Form>
            </Modal>

            {/* ── Delete Confirmation Modal ──────────────────────────────── */}
            <Modal
                open={deleteModalVisible}
                onCancel={() => { setDeleteModalVisible(false); setDeleteTarget(null); }}
                footer={null}
                centered
                width={420}
                closable={false}
                styles={{ body: { padding: 0 } }}
            >
                <div style={{ padding: '32px 28px 24px' }}>
                    {/* Icon */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
                        <div style={{
                            width: 64, height: 64, borderRadius: '50%',
                            background: '#fef2f2', border: '6px solid #fee2e2',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            <WarningOutlined style={{ fontSize: 28, color: '#dc2626' }} />
                        </div>
                    </div>

                    {/* Text */}
                    <div style={{ textAlign: 'center', marginBottom: 24 }}>
                        <Title level={4} style={{ margin: '0 0 8px', color: '#0f172a', fontWeight: 700 }}>
                            Delete Store
                        </Title>
                        <Text style={{ color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
                            Are you sure you want to delete{' '}
                            <span style={{ fontWeight: 700, color: '#0f172a' }}>
                                {deleteTarget?.name}
                            </span>
                            ? This will permanently remove the store, its settings, and all associated data. This action cannot be undone.
                        </Text>
                    </div>

                    {/* Warning box */}
                    <div style={{
                        background: '#fffbeb', border: '1px solid #fde68a',
                        borderRadius: 8, padding: '10px 14px', marginBottom: 24,
                        display: 'flex', alignItems: 'flex-start', gap: 8
                    }}>
                        <ExclamationCircleOutlined style={{ color: '#d97706', marginTop: 2, flexShrink: 0 }} />
                        <Text style={{ fontSize: 12, color: '#92400e' }}>
                            All drivers, orders, and delivery data linked to this store will also be permanently removed.
                        </Text>
                    </div>

                    {/* Buttons */}
                    <div style={{ display: 'flex', gap: 10 }}>
                        <Button
                            size="large"
                            block
                            style={{ borderRadius: 8, border: '1px solid #e2e8f0', color: '#64748b', fontWeight: 600 }}
                            onClick={() => { setDeleteModalVisible(false); setDeleteTarget(null); }}
                            disabled={deleteLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="large"
                            block
                            danger
                            type="primary"
                            loading={deleteLoading}
                            icon={<DeleteOutlined />}
                            style={{ borderRadius: 8, fontWeight: 700, background: '#dc2626', border: 'none' }}
                            onClick={handleDeleteStore}
                        >
                            {deleteLoading ? 'Deleting...' : 'Yes, Delete Store'}
                        </Button>
                    </div>
                </div>
            </Modal>
        </MainLayout>
    );
};

export default Dashboard;
